import React from 'react'

export default function About(props) {
  return (
    <div>
        <div className="container border-light card p-3 rounded-lg"  >
            <div className="row g-0">
                <div className="col-md-4">
                <img src={props.img} className="img-fluid rounded-start" alt="This is image"/>
                </div>
                <div className="col-md-8">
                <div className="card-body my-4">
                    <h3 className="card-title ">Welcome to <span style={{color: "#00838f" }} >College Book</span> </h3>
                    <h5 className="card-text " style={{fontFamily:"	Arial" }}>College Book is my
                     attempt to provide you access of the recommended book by your institution in a low cost of time
                     (Within the seconds). Apart from these you can also find here, the previous year question papers of
                     respective subjects of your departments.</h5>
                </div>
                </div>
            </div>
        </div>
        <div className='text-center'><h2>{props.title}</h2></div>
    </div>
  )
}
